<template>
    <PainelGrafico
        titulo="Pagos e Recebidos"
        v-model:aberto="mostrarGrafico"
        :carregando="carregando"
        :vazio="!carregando && !temDados"
        :dica="mes == null ? 'Clique em um mês para ver as semanas' : 'Clique em uma semana para ver o detalhe'"
    >
        <template #info>
            <v-menu location="end">
                <template v-slot:activator="{ props }">
                    <i v-bind="props" class="bi bi-info-circle" title="Sobre o indicador"></i>
                </template>
                <v-card min-width="100" style="max-width: 23rem; padding: 1rem">
                    <div>
                        <b>Fórmula:</b> Somatório dos valores pagos (Atrasado e Pago) e recebidos
                        (Atrasado, Cancelado e Recebido).<br>
                        <b>Polaridade:</b> Saldo: quanto maior, melhor.<br>
                        <b>Fonte:</b> OMIE > Finanças > Contas a Pagar/Receber.<br>
                        <b>Descrição:</b> Verde = recebidos, vermelho = pagos, amarelo = saldo.
                    </div>
                </v-card>
            </v-menu>
        </template>

        <Bar
            :options="dadosGrafico().options"
            :data="dadosGrafico().data"
            ref="barChart"
        />
    </PainelGrafico>
    <ModalDetalhesSaldo
        :lista="lista[0]"
        :semanaAno="semanaAno"
        v-if="showModal"
        @fecharModal="showModal = false"
    />
</template>

<script>
import serviceGraficos from '@/services/serviceGraficos.js';
import { Bar } from 'vue-chartjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
} from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';
import ModalDetalhesSaldo from '@/components/Modais/ModalDetalhesSaldo.vue';
import PainelGrafico from '@/components/PainelGrafico.vue';
import { getChartTheme, baseChartOptions } from '@/utils/chartTheme';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement
);

export default {
    name: 'GraficoPagosRecebidos',
    components: {
        Bar,
        ModalDetalhesSaldo,
        PainelGrafico,
    },
    props: {
        mes: { required: true },
        ano: { required: true },
    },
    emits: ['updateMes'],
    data() {
        return {
            data: null,
            mostrarGrafico: true,
            carregando: true,
            showModal: false,
            lista: [null],
            semanaAno: null,
        };
    },
    computed: {
        temDados() {
            const serie = this.mes
                ? this.data?.valorSemanaReceber
                : this.data?.valorMesReceber;
            return Boolean(serie?.length);
        },
    },
    watch: {
        mes: 'getDados',
        ano: 'getDados',
    },
    mounted() {
        this.getDados();
    },
    methods: {
        async getDados() {
            this.carregando = true;
            try {
                this.data = await serviceGraficos.getSaldoFinanceiro(this.mes, this.ano);
            } catch (error) {
                console.error('Erro ao obter dados:', error);
                this.data = null;
            } finally {
                this.carregando = false;
            }
        },
        dadosGrafico() {
            const theme = getChartTheme();
            const options = baseChartOptions({
                ...theme,
                onClick: (e) => {
                    if (!this.$refs.barChart?.chart || !this.data?.saldo) return;
                    const canvasPosition = getRelativePosition(e, this.$refs.barChart.chart);
                    const dataX = this.$refs.barChart.chart.scales.x.getValueForPixel(canvasPosition.x);
                    if (dataX == null || dataX < 0) return;
                    if (this.mes == null) {
                        this.$emit('updateMes', dataX + 1);
                    } else if (this.data.saldo[dataX]) {
                        this.mostrarLista(this.data.saldo[dataX].x.slice(0, 2));
                    }
                },
            });

            return {
                data: {
                    datasets: [
                        {
                            label: 'Saldo',
                            type: 'line',
                            backgroundColor: '#E1BB22',
                            borderColor: '#E1BB22',
                            tension: 0.2,
                            data: this.data?.saldo || [],
                        },
                        {
                            label: 'Recebidos',
                            backgroundColor: 'rgba(129, 199, 132, 1)',
                            borderRadius: 4,
                            data: this.mes
                                ? (this.data?.valorSemanaReceber || [])
                                : (this.data?.valorMesReceber || []),
                        },
                        {
                            label: 'Pagos',
                            backgroundColor: '#E13417',
                            borderRadius: 4,
                            data: this.mes
                                ? (this.data?.valorSemanaPagar || [])
                                : (this.data?.valorMesPagar || []),
                        },
                    ],
                },
                options,
            };
        },
        async mostrarLista(semana) {
            this.semanaAno = this.ano + semana;
            this.lista = await serviceGraficos.getDetalhesSaldo(this.ano + semana);
            this.showModal = true;
        },
    },
};
</script>
